import React from "react";
import {
  Label,
  FormGroup,
  Row,
  Col,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import { Info, ArrowRight } from "react-feather";
import { SelectFormField } from "./OfferFormFields";
import {
  rideTypeOptions,
  bookingSourceOptions,
} from "../../Constant/offerConstants";

// ===== Styles =====
const cardStyle = {
  border: "none",
  borderRadius: "16px",
  padding: "24px",
  height: "100%",
  backgroundColor: "#ffffff",
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
};

const cardHeaderStyle = (accentColor) => ({
  fontSize: "1.05rem",
  fontWeight: 600,
  color: accentColor,
  borderBottom: `2px solid ${accentColor}20`,
  paddingBottom: "12px",
  marginBottom: "20px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

const arrowContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
};

const arrowBadgeStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: "#e8f5e9",
  color: "#41CC7D",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 12px rgba(65, 204, 125, 0.2)",
};

// ===== Reusable Condition Card Renderer =====
const ConditionCard = ({ title, emoji, accentColor, config, errors, trigger, headerTooltipId, headerTooltipText }) => (
  <div style={cardStyle}>
    <div style={cardHeaderStyle(accentColor)}>
      <span>{emoji}</span> {title}
      {headerTooltipText && (
        <>
          <span
            id={headerTooltipId}
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              marginLeft: "4px",
            }}
          >
            <Info size={16} color={accentColor} />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={headerTooltipId}
            container="body"
          >
            {headerTooltipText}
          </UncontrolledTooltip>
        </>
      )}
    </div>
    <Row>
      <SelectFormField
        label="Booking Source"
        field={config.bookingSourceField}
        fieldName={config.bookingSourceName}
        errors={errors}
        colSize="12"
        isMulti
        enableCheckbox
        options={config.bookingSourceOptions}
        placeholder="Select Sources"
        onChange={(val) => {
          config.bookingSourceField.onChange(val);
          trigger(config.rideTypeName);
        }}
      />
      <SelectFormField
        label="Ride Type"
        field={config.rideTypeField}
        fieldName={config.rideTypeName}
        errors={errors}
        colSize="12"
        isMulti
        enableCheckbox
        options={rideTypeOptions}
        placeholder={
          config.bookingSourceField.value &&
          config.bookingSourceField.value.length > 0
            ? "Select Ride Types"
            : "Select Booking Source first"
        }
      />
      <SelectFormField
        label="Payment Type"
        field={config.paymentTypeField}
        fieldName={config.paymentTypeName}
        errors={errors}
        colSize="12"
        isMulti
        options={config.paymentTypeOptions}
        placeholder="Select Payment Types"
      />
      <FormGroup className="col-lg-12">
        <div className="d-flex align-items-center mb-2 gap-1">
          <Label className="mb-0" style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555" }}>
            Min distance travel <span className="text-danger">*</span>
          </Label>
          <span
            id={config.tooltipId}
            style={{
              cursor: "pointer",
              display: "inline-block",
              padding: "4px",
            }}
          >
            <Info size={16} color="#6c757d" />
          </span>
          <UncontrolledTooltip
            placement="right-start"
            target={config.tooltipId}
            container="body"
          >
            The offer will apply only when the user has travelled beyond this
            entered distance
          </UncontrolledTooltip>
        </div>
        <Input
          type="number"
          className="form-control"
          value={config.minDistanceField.value}
          onChange={config.minDistanceField.onChange}
          invalid={!!errors[config.minDistanceName]}
          placeholder="Enter min distance"
        />
        {errors[config.minDistanceName] && (
          <span className="text-danger">
            {errors[config.minDistanceName].message}
          </span>
        )}
      </FormGroup>
    </Row>
  </div>
);

const ConditionsTab = ({ triggerConfig, rewardConfig, errors, trigger }) => (
  <Row className="justify-content-center align-items-stretch">
    <Col md={5}>
      <ConditionCard
        title="Qualifying Ride Criteria"
        emoji="🎯"
        accentColor="#2196F3"
        config={triggerConfig}
        errors={errors}
        trigger={trigger}
        headerTooltipId="qualifyingCriteriaTooltip"
        headerTooltipText="Complete these rides to qualify for the offer."
      />
    </Col>
    <Col
      md={1}
      className="d-flex align-items-center justify-content-center"
    >
      <div style={arrowContainerStyle}>
        <div style={arrowBadgeStyle}>
          <ArrowRight size={24} strokeWidth={5} />
        </div>
      </div>
    </Col>
    <Col md={5}>
      <ConditionCard
        title="Reward Ride Criteria"
        emoji="🎁"
        accentColor="#41CC7D"
        config={rewardConfig}
        errors={errors}
        trigger={trigger}
        headerTooltipId="rewardCriteriaTooltip"
        headerTooltipText="The offer applies to these rides."
      />
    </Col>
  </Row>
);

export default ConditionsTab;
